var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition',[_c('v-btn',{staticStyle:{"margin-bottom":"30px","margin-right":"5px"},attrs:{"color":"dark","dark":"","fixed":"","bottom":"","right":"","fab":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }